module.exports = __webpack_public_path__ + "static/img/attack_english.ace155f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/attack_english.png
// module id = ZJ7m
// module chunks = 94